const bindRoomIndexToUpdateTravelersUtil = (roomIndex, updateTravelers) => (
  event,
  newTravelers
) => {
  updateTravelers(roomIndex, newTravelers);
};

export default bindRoomIndexToUpdateTravelersUtil;
